module.exports = __webpack_public_path__ + "static/media/mystery-boxes-nft-sr04.18ea9316.png";